import * as React from "react"
import type { IconProps } from "../types"

const Activity = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        {...props}
      >
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M2 12H6L9 3L15 21L18 12H22"
        />
      </svg>
    )
  }
)
Activity.displayName = "Activity"

export default Activity
